import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectOperacionState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';

@Component({
    selector: 'app-nuevo-cliente',
    templateUrl: './nuevo-cliente.component.html',
    styleUrls: ['./nuevo-cliente.component.scss'],
})
export class NuevoClienteComponent implements OnInit {
    @Output() cerrarNuevoCliente = new EventEmitter<Boolean>();
    @Output() nuevoCliente = new EventEmitter<{}>();
    @Input() edicionDatosCliente: any[];
    regimenFiscal: any;
    usoFactura: any;
    regFiscal: any;
    estado: any;
    pais: any;
    bloquearPaEsMun: boolean = false;
    datosAdicionales: boolean = false;
    contadorMostrarDatos: number;
    formDatosCliente: any;
    formDatosClienteAdicionales: any;
    lstPais: any;
    lstEstado: any;
    lstMunicipio: any;
    lstAsentamiento: any;
    codigoPostal: any;
    actualizar: any;
    datoseventCliente: any;
    modificarDatos: boolean = false;
    spinner: boolean = false;
    getStateOperacion: any;
    subscribeOperacion: any;
    idOperacion: any;
    constructor(
        public dialog: MatDialog,
        private fb: FormBuilder,
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService
    ) { }

    ngOnInit() {
        this.getStateOperacion = this.store.select(selectOperacionState);
        // this.subscribeOperacion = this.getStateOperacion.subscribe((operacion) => {
        //     this.idOperacion = operacion.idOperacion;
        // });
        this.contadorMostrarDatos = 0;
        this.datosAdicionales = false;
        this.modificarDatos = false;
        this.formularioCliente();
        this.formularioClienteDatoAdicional();
        this.getPais();
        this.CFDI();
        if (this.edicionDatosCliente.length > 0) {
            //console.log(this.edicionDatosCliente[0].idPais)
            setTimeout(() => this.ACTCliente(), 1000);
            //console.log(this.edicionDatosCliente[0].CP, "codigo postal");
            this.modificarDatos = true;
        }



    }

    mostrarDatosAdicionales() {
        this.contadorMostrarDatos++;
        if (this.contadorMostrarDatos % 2) {
            this.datosAdicionales = true;
            this.formDatosClienteAdicionales.enable();
            this.bloquearPaEsMun = true;
        } else {
            this.datosAdicionales = false;
            this.formDatosClienteAdicionales.disable();
            //this.formDatosClienteAdicionales.reset();
            this.formDatosCliente.controls.cP.reset();
            this.bloquearPaEsMun = false;
        }
    }
    cerrarCliente() {
        this.formDatosCliente.reset();
        this.formDatosClienteAdicionales.reset();
        this.edicionDatosCliente.length = 0;
        setTimeout(() => this.cerrarNuevoCliente.emit(false), 500);
    }

    formularioCliente() {
        this.formDatosCliente = this.fb.group({
            nombreRazonSocial: new FormControl('', Validators.required),
            rFC: new FormControl('', Validators.required),
            usoDeLaFactura: new FormControl('', Validators.required),
            regimenFiscal: new FormControl('', Validators.required),
            eMail: new FormControl('', Validators.required),
            eMailOpcionalNo1: new FormControl(),
            eMailOpcionalNo2: new FormControl(),
            cP: new FormControl(),
        });
        

    }

    formularioClienteDatoAdicional() {
        this.formDatosClienteAdicionales = this.fb.group({
            calle: new FormControl(),
            noExterior: new FormControl(),
            noInterior: new FormControl(),
            colonia: new FormControl(),
            localidad: new FormControl(),
            municipio: new FormControl(),
            estado: new FormControl(),
            pais: new FormControl(),
        });
    }

    InsertarCliente() {
        if (!this.formDatosCliente.valid)
            return this._snackBar.open('Favor de completar los datos requeridos', 'OK', { duration: 3000 });
        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea guardar este registro?' });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                this.spinner = true;
                var datosCliente = this.formDatosCliente.value;
                var datosClienteAdicionales = this.formDatosClienteAdicionales.value;
                const body = {

                    nombreRazonSocial: datosCliente.nombreRazonSocial.substring(0, 254),
                    RFC: datosCliente.rFC,
                    usoFactura: datosCliente.usoDeLaFactura,
                    regimenFiscal: datosCliente.regimenFiscal,
                    eMail: datosCliente.eMail,
                    eMailOpcional1: datosCliente.eMailOpcionalNo1,
                    eMailOpcional2: datosCliente.eMailOpcionalNo2,
                    CP: datosCliente.cP,
                    calle: datosClienteAdicionales.calle,
                    noExterior: datosClienteAdicionales.noExterior,
                    noInterior: datosClienteAdicionales.noInterior,
                    pais: datosClienteAdicionales.pais,
                    estado: datosClienteAdicionales.estado,
                    municipio: datosClienteAdicionales.municipio,
                    localidad: datosClienteAdicionales.localidad,
                    colonia: datosClienteAdicionales.colonia,
                    idRol: 2,
                    idOperacion: this.idOperacion
                }
                


                this.srvcoal.postService(`catalogo/PostInsCliente`, body).subscribe((res: any) => {
                    if (res.err) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    } else if (res.excepcion) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                    } else {
                        this._snackBar.open(res.data, 'ok', { duration: 3000 });
                        this.nuevoCliente.emit(res.data)
                        //console.log(res.recordsets[0][0].mensaje)
                        this.formDatosCliente.reset();
                        this.formDatosClienteAdicionales.reset();
                        this.cerrarCliente();
                        this.spinner = false;

                    }
                }, (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                    this.store.dispatch(OcultarSpinner())
                    this.spinner = false;
                });
            } else {
                this._snackBar.open('Registro cancelado', 'OK', { duration: 3000 });
                this.store.dispatch(OcultarSpinner());
                this.spinner = false;
            }
        });
    }

    UPDCliente() {
        if (!this.formDatosCliente.valid)
            return this._snackBar.open('Favor de completar los datos requeridos', 'OK', { duration: 3000 });
        if (this.actualizar)
            return this._snackBar.open('Operación no válida', 'OK', { duration: 3000 });
        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea actualizar este registro?' });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                this.spinner = true;
                var datosCliente = this.formDatosCliente.value;
                var datosClienteAdicionales = this.formDatosClienteAdicionales.value;
                const body = {

                    nombreRazonSocial: datosCliente.nombreRazonSocial,
                    RFC: datosCliente.rFC,
                    usoFactura: datosCliente.usoDeLaFactura,
                    regimenFiscal: datosCliente.regimenFiscal,
                    eMail: datosCliente.eMail,
                    eMailOpcional1: datosCliente.eMailOpcionalNo1,
                    eMailOpcional2: datosCliente.eMailOpcionalNo2,
                    CP: datosCliente.cP,
                    calle: datosClienteAdicionales.calle,
                    noExterior: datosClienteAdicionales.noExterior,
                    noInterior: datosClienteAdicionales.noInterior,
                    pais: datosClienteAdicionales.pais,
                    estado: datosClienteAdicionales.estado,
                    municipio: datosClienteAdicionales.municipio,
                    localidad: datosClienteAdicionales.localidad,
                    colonia: datosClienteAdicionales.colonia,
                    idRol: 2,
                    idOperacion: this.idOperacion,
                    idCliente: this.edicionDatosCliente[0].idCliente,
                    idDireccion: this.edicionDatosCliente[0].idDireccion
                }
                

                this.srvcoal.postService(`catalogo/PostUPDCliente`, body).subscribe(
                    (res: any) => {
                        if (res.err) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                        } else if (res.excepcion) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                        } else {
                            this._snackBar.open(res.recordsets[0][0].mensaje, 'ok', { duration: 3000 });
                            this.formDatosCliente.reset();
                            this.formDatosClienteAdicionales.reset();
                            this.cerrarCliente();
                            this.spinner = false;

                        }
                    }, (error: any) => {
                        this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                        this.store.dispatch(OcultarSpinner());
                        this.spinner = false;
                    }
                );
            } else {
                this._snackBar.open('Registro cancelado', 'OK', { duration: 3000 });
                this.store.dispatch(OcultarSpinner());
                this.spinner = false;
            }
        });
        this.spinner = false;
    }

    ACTCliente() {
        this.formDatosCliente.controls.nombreRazonSocial.setValue(this.edicionDatosCliente[0].nombreRazonSocial);
        this.formDatosCliente.controls.rFC.setValue(this.edicionDatosCliente[0].RFC);
        
        this.formDatosCliente.controls.usoDeLaFactura.setValue(this.edicionDatosCliente[0].usoFactura);
        this.formDatosCliente.controls.regimenFiscal.setValue(this.edicionDatosCliente[0].regimenFiscal);
        this.formDatosCliente.controls.eMail.setValue(this.edicionDatosCliente[0].eMail);
        this.formDatosCliente.controls.eMailOpcionalNo1.setValue(this.edicionDatosCliente[0].eMailOpcional1);
        this.formDatosCliente.controls.eMailOpcionalNo2.setValue(this.edicionDatosCliente[0].eMailOpcional2);
        this.formDatosCliente.controls.cP.setValue(this.edicionDatosCliente[0].CP);
        if (this.edicionDatosCliente[0].CP != null) {
            setTimeout(() => this.mostrarDatosAdicionales(), 1000);
            this.formDatosClienteAdicionales.controls.pais.setValue(this.edicionDatosCliente[0].idPais);
            this.changePais(this.edicionDatosCliente[0].idPais)
            this.formDatosClienteAdicionales.controls.estado.setValue(this.edicionDatosCliente[0].idEstado);
            this.changeEntidad(this.edicionDatosCliente[0].idEstado);
            this.formDatosClienteAdicionales.controls.municipio.setValue(this.edicionDatosCliente[0].idMunicipio);
            this.changeMunicipio(this.edicionDatosCliente[0].idMunicipio);
            this.formDatosClienteAdicionales.controls.localidad.setValue(this.edicionDatosCliente[0].idAsentamiento);
            this.formDatosClienteAdicionales.controls.colonia.setValue(this.edicionDatosCliente[0].localidad);
        }
        this.formDatosClienteAdicionales.controls.calle.setValue(this.edicionDatosCliente[0].calle);
        this.formDatosClienteAdicionales.controls.noExterior.setValue(this.edicionDatosCliente[0].noExterior);
        this.formDatosClienteAdicionales.controls.noInterior.setValue(this.edicionDatosCliente[0].noInterior);

        //console.log(this.edicionDatosCliente);

    }

    actualizarCliente(edicionDatosCliente) {
        try {
            this.edicionDatosCliente = edicionDatosCliente.data;
            setTimeout(() => this.ACTCliente(), 1000);

        } catch (error) {
            this.Excepciones(error, 1);
        }
    }
    Excepciones(pila, tipoExcepcion: number) {
        try {
            const dialogRef = this.dialog.open(ExcepcionesComponent, {
                width: '60%',
                data: {
                    idTipoExcepcion: tipoExcepcion,
                    idUsuario: 1,
                    idOperacion: 1,
                    idAplicacion: 1,
                    moduloExcepcion: 'sel-caja-historial.component',
                    mensajeExcepcion: '',
                    stack: pila,
                },
            });
            dialogRef.afterClosed().subscribe((result: any) => { });
        } catch (error) {
            // console.error(error);
        }
    }


    CFDI() {
        this.srvcoal.getService('catalogo/GetSelCFDI').subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.usoFactura = res.recordsets[0];
                    this.regFiscal = res.recordsets[1];
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    getPais() {
        this.srvcoal.getService('catalogo/GetPais').subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.lstPais = res.recordsets[0];
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    changePais(value) {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`catalogo/GetEstado?idPais=${value}`).subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.lstEstado = res.recordsets[0];
                    this.store.dispatch(OcultarSpinner());
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    changeEntidad(value) {
        let idPais = this.formDatosClienteAdicionales.controls.pais.value;
        let entidad = value;
        this.store.dispatch(MostrarSpinner());
        this.srvcoal
            .getService(
                `catalogo/GetMunicipio?idPais=${idPais}&idEstado=${entidad}`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.lstMunicipio = res.recordsets[0];
                        this.store.dispatch(OcultarSpinner());
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                }
            );
    }

    changeMunicipio(value) {
        let idPais = this.formDatosClienteAdicionales.controls.pais.value;
        let entidad = this.formDatosClienteAdicionales.controls.estado.value;
        let municipio = value;
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;
        this.srvcoal
            .getService(
                `catalogo/GetAsentamiento?idPais=${idPais}&idEstado=${entidad}&idMunicipio=${municipio}`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.lstAsentamiento = res.recordsets[1];
                        this.store.dispatch(OcultarSpinner());
                        this.spinner = false;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }
            );
    }

    changeColonia(value) {
        let idPais = this.formDatosClienteAdicionales.controls.pais.value;
        let entidad = this.formDatosClienteAdicionales.controls.estado.value;
        let municipio =
            this.formDatosClienteAdicionales.controls.municipio.value;
        let colonia = value;
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;
        this.srvcoal
            .getService(
                `catalogo/GetCP?idPais=${idPais}&idEstado=${entidad}&idMunicipio=${municipio}&idAsentamiento=${colonia}`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.codigoPostal = res.recordsets[0][0].CP;
                        //console.log(res.recordsets[0][0].CP)
                        this.formDatosClienteAdicionales.controls['cp'].setValue(this.codigoPostal);
                        this.store.dispatch(OcultarSpinner());
                        // this.spinner = false;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }
            );
    }

    consultarCP() {
        if (this.formDatosCliente.controls.cP.value === null)
            return this._snackBar.open("Ingrese un CP", 'Ok', { duration: 10000 });
        let CP = this.formDatosCliente.controls.cP.value;
        if (this.formDatosCliente.controls.cP.valid === false) {
            this._snackBar.open('Verifique el código postal', 'ok', {
                duration: 3000,
            });
        } else {
            this.store.dispatch(MostrarSpinner());
            this.spinner = true;
            this.srvcoal.getService(`catalogo/GetCP_Origen?CP=${CP}`).subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        let exito = res.recordsets[0][0].mensaje;
                        if (exito == 'Éxito') {
                            let origen = res.recordsets[0];
                            this.getPais();
                            this.formDatosClienteAdicionales.controls.pais.setValue(
                                origen[0].idPais
                            );
                            this.changePais(origen[0].idPais);
                            this.formDatosClienteAdicionales.controls.estado.setValue(
                                origen[0].idEstado
                            );
                            this.changeEntidad(origen[0].idEstado);
                            this.formDatosClienteAdicionales.controls.municipio.setValue(
                                origen[0].idMunicipio
                            );
                            this.changeMunicipio(origen[0].idMunicipio);
                            this.formDatosClienteAdicionales.controls.colonia.setValue(
                                origen[0].idAsentamiento
                            );
                            this.formDatosClienteAdicionales.controls.localidad.setValue(
                                origen[0].idAsentamiento
                            );
                            this.mostrarDatosAdicionales();

                        } else {
                            this._snackBar.open(exito, 'OK', {
                                duration: 3000,
                            });
                        }
                        this.store.dispatch(OcultarSpinner());
                        this.spinner = false;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }
            );
        }
    }
}
